import type { FaireProductEntity } from "../../entity_types/product";

export const p_t9tt33bgz3: FaireProductEntity = {
  token: "p_t9tt33bgz3",
  type: "product",
  name: "Men's Ascent UPF50 Sun Hoodie (Discontinued Styles)",
  brandToken: "b_409pab9jko",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/c058dc7411141070f764b0200c3288a0e41d8b64c2398a93f8889ff82ffa0604.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/2f7190d06c8d275bffd3ca51f22986870052306f83dfa4f89437573b43d317f4.jpeg",
    "https://cdn.faire.com/fastly/22dbd3f8d490d89be20983de9c032a517bcb593950db1259de88935b4d583eb4.jpeg",
    "https://cdn.faire.com/fastly/641c79a21d9cf7011688e4b3365c2929670715a674a0b4e78e32074d754e0b0d.jpeg",
    "https://cdn.faire.com/fastly/d1d5f3f0fc10bca15e64448150921a722a0d01a960f519ca8aaf4adcbccfa60e.jpeg",
    "https://cdn.faire.com/fastly/bdd93c6f623012371940f1b2b15498aa498bdbf46036dbf10ecee9d3c7af00da.jpeg",
    "https://cdn.faire.com/fastly/9e003b38240d4801a874c45fce644734f64cb4ab7d2555e42ca0700240a7164e.jpeg",
    "https://cdn.faire.com/fastly/2852532bce66ec6626c714ecc0ff1d19c9c2b792579a498f594407dccc4948dd.jpeg",
    "https://cdn.faire.com/fastly/1038ddabbf4c0cb1830f27f1947c01e26616ad46a1ce72017d0af50865dace48.jpeg",
    "https://cdn.faire.com/fastly/4bd886dfb6543cd549413080ad9a21f8847b865d4cb1dc6805ba8b1ced9b71e5.jpeg",
    "https://cdn.faire.com/fastly/91ccaac6b996be32ee006c67ff3ef0a19fc15df660759bc23e89a833cf8de2ab.jpeg",
    "https://cdn.faire.com/fastly/a9a8ab3463a5d78608e07fc0ab5367854b6c8e7929ded797d439dc4eee80331e.jpeg",
    "https://cdn.faire.com/fastly/3b50746893b3e8e21144b77cabbf05a12319c0a23348500eb34f37a336c6e192.png",
    "https://cdn.faire.com/fastly/b804516a92ed4e6f78e529961d6b14b4b9078789a5bf706628087ec503598b18.jpeg",
    "https://cdn.faire.com/fastly/40dab6025317ceb36a855c1b18e464eb913582311a2b64e2d6e9b53713cc96d7.jpeg",
    "https://cdn.faire.com/fastly/161890fd9617470dab7ccb2cac06d5b353243c2f2d3ea2a457eaa61030464683.jpeg",
    "https://cdn.faire.com/fastly/b836471b7f23203f58061791fabe408b5ba1b653d6761f02341fde518efc3eff.jpeg",
    "https://cdn.faire.com/fastly/7696505aba373d9dc6feb7e93622392a75a8d651d79c69e729f99acad171b135.jpeg",
    "https://cdn.faire.com/fastly/e955083cc8b887fe105f35f3b54824f2659e20b3746baf66549cf4f3f075cdb1.jpeg",
    "https://cdn.faire.com/fastly/54b8b284be733a789381f2fb0ce4947be9900682ee3d8fa3cc8ee9b1e04efe19.jpeg",
    "https://cdn.faire.com/fastly/ec321ff83c9f7180f102a49e82e24e8153a8c0c46702d50f2ca6c8f0a4396459.jpeg",
    "https://cdn.faire.com/fastly/a7011f5e7fa72b65019017d2bf95bd18f518c93885a9cd8d9df3f1cbcd012f0d.jpeg",
    "https://cdn.faire.com/fastly/a483f3d739a9789e0a2f41767c33f17f222ff428c147d14aad581567f7c649fb.png",
    "https://cdn.faire.com/fastly/d7919130c07850d5d5a1f1f02b4c3e7bb59f3787c0c5dfb55229c5a042cb50e1.jpeg",
    "https://cdn.faire.com/fastly/78ed5d828a2a3a3d5a367aab71cce7ce0589e3b734179a282f516ba57369dbe8.jpeg",
    "https://cdn.faire.com/fastly/1c08a45022c158419670b7c4d81ffa0fd96f081ac11da0efc0ccd9bbf4dd2f89.jpeg",
    "https://cdn.faire.com/fastly/275bfdefac481a81a70629eb883199d67ab4be0b49287468677d4948ca9ace54.jpeg",
    "https://cdn.faire.com/fastly/dc99c28acc9c7518522f9b34be727917db0ddd18ab6bda3bbcff3c9f9d30bc1c.jpeg",
    "https://cdn.faire.com/fastly/064db14647da1e2f000434986cc9ab4ace42ffd043d54ed7171a6ef0a5e3286c.jpeg",
    "https://cdn.faire.com/fastly/d085f523a84ee59d9fb2ff3f10bf8a1b06e3d2f2f7754933c8380679d581235b.jpeg",
  ],
  priceDollars: 51.27,
  description:
    "Stay protected from the sun with our Ascent Sun Hoodie. Made from a lightweight fabric that’s breathable and comfortable, these hoodies offer all-day comfort, protection, and style for your favorite Summer adventures.\n",
  tags: [],
  msrpDollars: 102.54,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:26:33.250Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
